import { render } from "./CustomBlock.vue?vue&type=template&id=15d15d8a"
import script from "./CustomBlock.vue?vue&type=script&lang=js"
export * from "./CustomBlock.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__